// SyntraMfgPackagingHub.jsx
import React, { useState } from "react";

export default function SyntraMfgPackagingHub() {
  const [activeTab, setActiveTab] = useState("marketplace");
  const [searchQuery, setSearchQuery] = useState("");
  const [showSearchResults, setShowSearchResults] = useState(false);

  // Dummy Data
  const marketplaceData = [
    { id: 1, name: "Cardboard Boxes - Small", type: "Primary", price: 25 },
    { id: 2, name: "Plastic Bottle - 500ml", type: "Primary", price: 12 },
    { id: 3, name: "Custom Printed Labels", type: "Label", price: 5 },
    { id: 4, name: "Secondary Cartons", type: "Secondary", price: 50 },
    { id: 5, name: "Shrink Wrap Film", type: "Tertiary", price: 30 },
  ];

  const manufacturerData = [
    { id: 1, name: "PackPro Industries", location: "Mumbai", rating: 4.5 },
    { id: 2, name: "EcoPack Solutions", location: "Delhi", rating: 4.7 },
    { id: 3, name: "LabelArt Pvt Ltd", location: "Bangalore", rating: 4.2 },
  ];

  const wikiData = [
    { id: 1, topic: "Primary Packaging", content: "Packaging in direct contact with the product." },
    { id: 2, topic: "Secondary Packaging", content: "Packaging that groups primary packages together." },
    { id: 3, topic: "Tertiary Packaging", content: "Used for storage and transportation of multiple units." },
    { id: 4, topic: "Labeling Guidelines", content: "Regulations for product information and branding." },
  ];

  const calculatorsData = [
    { id: 1, name: "Cost Estimator", formula: "Units × Price per Unit" },
    { id: 2, name: "Volume/Weight Calculator", formula: "Calculate packaging dimensions" },
    { id: 3, name: "Carbon Footprint Estimator", formula: "Estimate environmental impact" },
  ];

  const innovationsData = [
    { id: 1, name: "Biodegradable Films", description: "Eco-friendly material alternatives." },
    { id: 2, name: "Smart Packaging", description: "IoT-enabled packaging for tracking." },
    { id: 3, name: "Anti-Counterfeit Labels", description: "Tamper-proof labeling technology." },
  ];

  const handleSearch = () => {
    setShowSearchResults(true);
  };

  return (
    <div className="min-h-screen bg-stone-500 p-4">
      <h1 className="text-3xl font-bold text-center bg-stone-800 text-white mb-6 rounded-xl px-4 py-4">
        🌐 Think5Whys Packaging Hub
      </h1>

      {/* Search Panel */}
      <div className="flex flex-row justify-center gap-2 mb-2 px-4 py-2 mt-2 rounded-lg bg-gray-600">
        <input
          type="text"
          placeholder="Search packaging, manufacturers, or topics..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="px-4 rounded-lg w-2/3 h-10 mt-2 mb-2"
        />
        <button
          onClick={handleSearch}
          className="w-24 h-10 bg-purple-700 hover:bg-purple-800 text-white px-4 rounded-lg mt-2 mb-2"
        >
          🔍
        </button>
      </div>

      {showSearchResults && (
        <div className="bg-gray-700 rounded-lg p-4 mb-6 max-w-4xl mx-auto">
          <h2 className="text-whitefont-bold text-lg mb-2">Search Results for "{searchQuery}"</h2>
          <ul className="text-white list-disc pl-5 space-y-1">
            <li>Example Product / Packaging Type 1</li>
            <li>Example Manufacturer / Supplier 1</li>
            <li>Example Wiki Topic / Article 1</li>
            <li>Example Calculator / Tool 1</li>
          </ul>
        </div>
      )}

      {/* Tabs */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-2 mb-4 justify-items-center">
  {[
    { id: "marketplace", label: "Marketplace" },
    { id: "labelDesigner", label: "Label Designer" },
    { id: "calculators", label: "Calculators" },
    { id: "wiki", label: "Packaging Wiki" },
    { id: "manufacturers", label: "Manufacturers" },
    { id: "innovations", label: "Innovations" },
  ].map((tab) => (
    <button
      key={tab.id}
      onClick={() => setActiveTab(tab.id)}
      className={`px-4 py-2 rounded-lg font-semibold transition-colors duration-200 w-full
        ${activeTab === tab.id ? "bg-purple-700 text-white" : "bg-white text-black hover:bg-gray-200"}`}
    >
      {tab.label}
    </button>
  ))}
</div>



      {/* Tab Content */}
      <div className="max-w-6xl mx-auto bg-gray-600 rounded-lg p-4 shadow-lg">
        {activeTab === "marketplace" && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {marketplaceData.map((item) => (
              <div
                key={item.id}
                className="bg-stone-600 p-4 rounded-lg shadow hover:shadow-lg transition"
              >
                <h3 className="font-bold mb-2">{item.name}</h3>
                <p>Type: {item.type}</p>
                <p>Price: ₹{item.price}</p>
                <button className="mt-2 bg-purple-600 hover:bg-purple-700 text-white px-3 py-1 rounded-lg">
                  Add to Cart
                </button>
              </div>
            ))}
          </div>
        )}

        {activeTab === "labelDesigner" && (
          <div>
            <h2 className="font-bold mb-2 text-lg">Label Designer</h2>
            <p className="mb-4 text-sm text-gray-700">
              Drag-and-drop elements to design your product label (mock interface)
            </p>
            <div className="bg-stone-600 h-60 flex items-center justify-center rounded-lg mb-4">
              <p className="text-gray-800">[Label Designer Canvas]</p>
            </div>
            <button className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-lg">
              Export Label
            </button>
          </div>
        )}

        {activeTab === "calculators" && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {calculatorsData.map((calc) => (
              <div key={calc.id} className="bg-stone-600 p-4 rounded-lg shadow">
                <h3 className="font-bold mb-2">{calc.name}</h3>
                <p className="text-sm">{calc.formula}</p>
                <button className="mt-2 bg-purple-600 hover:bg-purple-700 text-white px-3 py-1 rounded-lg">
                  Open Calculator
                </button>
              </div>
            ))}
          </div>
        )}

        {activeTab === "wiki" && (
          <div className="space-y-4">
            {wikiData.map((item) => (
              <div key={item.id} className="bg-stone-600 p-4 rounded-lg shadow">
                <h3 className="font-bold mb-1">{item.topic}</h3>
                <p className="text-sm">{item.content}</p>
              </div>
            ))}
          </div>
        )}

        {activeTab === "manufacturers" && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {manufacturerData.map((man) => (
              <div key={man.id} className="bg-stone-600 p-4 rounded-lg shadow">
                <h3 className="font-bold mb-2">{man.name}</h3>
                <p>Location: {man.location}</p>
                <p>Rating: {man.rating} ⭐</p>
                <button className="mt-2 bg-purple-600 hover:bg-purple-700 text-white px-3 py-1 rounded-lg">
                  Contact
                </button>
              </div>
            ))}
          </div>
        )}

        {activeTab === "innovations" && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {innovationsData.map((item) => (
              <div key={item.id} className="bg-stone-600 p-4 rounded-lg shadow">
                <h3 className="font-bold mb-2">{item.name}</h3>
                <p className="text-sm">{item.description}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
